import PropTypes from 'prop-types';
import { FieldArray } from 'formik';
import { NumericFormat } from 'react-number-format';
// material
import {
  Stack,
  TextField,
  Box,
  Card,
  CardHeader,
  IconButton,
  Fab,
  InputAdornment,
  Grid
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
// material
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import trashFill from '@iconify/icons-eva/trash-2-fill';

const CardStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  marginBottom: theme.spacing(2),
  border: `1px dashed ${grey[300]}`
}));

TicketFormVouchers.propTypes = {
  formik: PropTypes.object.isRequired
};

export default function TicketFormVouchers({ formik }) {
  const { values, errors, touched, getFieldProps } = formik;

  return (
    <>
      <FieldArray
        name="vouchers"
        render={(fieldArrayHelpers) => (
          <>
            {values.vouchers.map((_, i) => (
              <CardStyle key={i}>
                <CardHeader
                  title={`Voucher ${i + 1}`}
                  action={
                    i > 0 && (
                      <IconButton
                        color="error"
                        aria-label="delete"
                        onClick={() => fieldArrayHelpers.remove(i)}
                      >
                        <Icon icon={trashFill} />
                      </IconButton>
                    )
                  }
                />
                <Stack spacing={2} sx={{ p: 2 }}>
                  <TextField
                    fullWidth
                    label="Code*"
                    {...getFieldProps(`vouchers.${i}.code`)}
                    error={Boolean(
                      touched.vouchers &&
                        touched.vouchers[i]?.code &&
                        errors.vouchers &&
                        errors.vouchers[i]?.code
                    )}
                    helperText={
                      touched.vouchers &&
                      touched.vouchers[i]?.code &&
                      errors.vouchers &&
                      errors.vouchers[i]?.code
                    }
                  />

                  <Grid container>
                    <Grid item xs={6} pr={1}>
                      <NumericFormat
                        fullWidth
                        label="Discount (0 - 100%)*"
                        {...getFieldProps(`vouchers.${i}.discount`)}
                        error={Boolean(
                          touched.vouchers &&
                            touched.vouchers[i]?.discount &&
                            errors.vouchers &&
                            errors.vouchers[i]?.discount
                        )}
                        helperText={
                          touched.vouchers &&
                          touched.vouchers[i]?.discount &&
                          errors.vouchers &&
                          errors.vouchers[i]?.discount
                        }
                        decimalScale={0}
                        customInput={TextField}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} pl={1}>
                      <NumericFormat
                        fullWidth
                        label="Limit*"
                        {...getFieldProps(`vouchers.${i}.limit`)}
                        error={Boolean(
                          touched.vouchers &&
                            touched.vouchers[i]?.limit &&
                            errors.vouchers &&
                            errors.vouchers[i]?.limit
                        )}
                        helperText={
                          touched.vouchers &&
                          touched.vouchers[i]?.limit &&
                          errors.vouchers &&
                          errors.vouchers[i]?.limit
                        }
                        decimalScale={0}
                        customInput={TextField}
                      />
                    </Grid>
                  </Grid>
                </Stack>
              </CardStyle>
            ))}

            <Box sx={{ textAlign: 'center', mt: -3 }}>
              <Fab
                size="medium"
                color="primary"
                aria-label="add"
                onClick={() => fieldArrayHelpers.push({ code: '', discount: '', limit: '' })}
              >
                <Icon icon={plusFill} width="24" />
              </Fab>
            </Box>
          </>
        )}
      />
    </>
  );
}
